import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Container, Tabs, Tab, Box, Typography } from '@mui/material';
import Form from './ProjectDetails/Form';
import Events from './ProjectDetails/Events';
import Users from './ProjectDetails/Users';

function TabPanel({ children, value, index }) {
  return value === index && (
    <Box sx={{ pt: 2 }}>
      {children}
    </Box>
  );
}

export default function ProjectDetail({ project }) {
  const [tabIndex, setTabIndex] = useState(0);
  const [form, setForm] = useState({});
  const [values, setValues] = useState([]);

  const tabs = [
    { label: 'Events', component: <Events project={project} /> },
    { label: 'Users', component: <Users project={project} /> },
    { label: 'Form', component: <Form project={project} /> },
    { label: 'Config', component: <div>Config</div> },
    { label: 'Preview', component: <div>Preview</div> },
  ];

  useEffect(() => {
    if (!project?.forms || project.forms.length === 0) return;

    const fid = project.forms[0].id;

    axios.get(`/api/form/form/${fid}`)
      .then(res => setForm(res.data))
      .catch(err => console.error("Failed to fetch form details:", err));
  }, [project]);

  const handleTabChange = (_, newValue) => setTabIndex(newValue);

  return (
    <Container
      maxWidth="xl"
      sx={{ mt: 3 }}
    >
      <Typography variant="h6" gutterBottom>
        {project.title} Project
      </Typography>
      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        indicatorColor='primary'
        textColor='primary'
        sx={{
          borderBottom: 1,
          borderColor: 'divider'
        }}
      >
        {tabs.map((tab, index) => (
          <Tab key={index} label={tab.label} />
        ))}
      </Tabs>

      {tabs.map((tab, index) => (
        <TabPanel key={index} value={tabIndex} index={index}>
          {tab.component}
        </TabPanel>
      ))}
    </Container>
  );
}